import { MAP_CENTERED_ON_THRESHOLD_DEGREES } from '../constants/config';
export const isCenteredOn = (mapCenter, target) => Math.abs(mapCenter.latitude - target.latitude) < MAP_CENTERED_ON_THRESHOLD_DEGREES &&
    Math.abs(mapCenter.longitude - target.longitude) < MAP_CENTERED_ON_THRESHOLD_DEGREES;
